import { PureComponent } from "react";
import ParagraphAndAssetComponent from "/components/core/paragraph-and-asset-columns/paragraph-and-asset-columns-component";
import cloneDeep from "lodash/cloneDeep";

export default class MultipleTabsComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  tabsRenderer() {
    const { tabs } = this.props;

    return tabs.map((tab, index) => {
      let { paragraphAndAssetColumns } = tab;
      let copyParagraphAndAssetColumns = cloneDeep(paragraphAndAssetColumns);

      if (copyParagraphAndAssetColumns && copyParagraphAndAssetColumns.content) {
        copyParagraphAndAssetColumns.content = { ...copyParagraphAndAssetColumns.content, title: tab.tabLabel };
      }

      return <ParagraphAndAssetComponent {...copyParagraphAndAssetColumns} key={index} />;
    });
  }

  render() {
    return <div className="multiple-tabs-component">{this.tabsRenderer()}</div>;
  }
}

MultipleTabsComponent.defaultProps = {
  tabs: []
};
